import type { CartAddressData } from 'services/types';
import type { BillingAddressFields } from './types';

/** Resolves form values first, then saved values, with empty strings as fallbacks. */
export function getBillingAddressFields(
  billingAddress: CartAddressData | undefined,
  billingFormData: Partial<BillingAddressFields> | undefined
): BillingAddressFields {
  return {
    city: billingFormData?.city ?? billingAddress?.city ?? '',
    country: billingFormData?.country ?? billingAddress?.country ?? '',
    firstName: billingFormData?.firstName ?? billingAddress?.firstName ?? '',
    lastName: billingFormData?.lastName ?? billingAddress?.lastName ?? '',
    street: billingFormData?.street ?? billingAddress?.street ?? '',
    zip: billingFormData?.zip ?? billingAddress?.zip ?? '',
    company: billingFormData?.company ?? billingAddress?.company ?? '',
    phone: billingFormData?.phone ?? billingAddress?.phone ?? '',
    salesTaxId: billingFormData?.salesTaxId ?? billingAddress?.salesTaxId ?? '',
    streetAddOn: billingFormData?.streetAddOn ?? billingAddress?.streetAddOn ?? ''
  };
}
